import StoreConnector from '@/helpers/StoreConnector'
import AuthorizationApi from 'api-client/Authorization.api'

const AuthenticationService = {
  async getAllUserRoles(dealerId) {
    let allUserRoles = await AuthorizationApi.getAllUserRoles(dealerId)
    StoreConnector.dispatch('authorization/setAllUserRoles', allUserRoles)
    return allUserRoles
  },
  async postAdminAuthorization(params) {
    await AuthorizationApi.postAdminAuthorization(params)
  },
  async deleteAdminAuthorization(params) {
    await AuthorizationApi.deleteAdminAuthorization(params)
  },
}

export default AuthenticationService
